import { Box, useTheme } from '@mui/material';
import { ReactNode } from 'react';

export interface ICustomMenuIconProps {
  handleOnclick?: () => void;
  Icon: ReactNode;
  isSelected?: boolean;
}

export const CustomMenuIcon = (props: ICustomMenuIconProps) => {
  const { handleOnclick, Icon, isSelected = false } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        '& .MuiSvgIcon-root path': {
          fill: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
        },
        height: 20,
      }}
      onClick={() => handleOnclick && handleOnclick()}
    >
      {Icon}
    </Box>
  );
};
